import React from 'react'
import PropTypes from 'prop-types'
import { Popconfirm, notification, Button, Typography } from 'antd'
import { Queries } from 'admin/lib/Api'
import * as Icons from '@ant-design/icons'

export function ResetUserPasswordButton({ userId }) {
  const resetPassword = Queries.useUserResetPassword()

  const handleResetPassword = () => {
    const workingKey = 'RESETING_PASSWORD'
    notification.info({
      key: workingKey,
      icon: <Icons.LoadingOutlined />,
      message: 'Sending Password Reset',
      duration: 0
    })
    resetPassword.mutate(
      { userId },
      {
        onSuccess: () => {
          notification.success({
            message: 'Password reset successful'
          })
        },
        onSettled: () => {
          notification.destroy(workingKey)
        },
        onError: error => {
          notification.error({
            message: 'Error 😞',
            description: (
              <Typography.Text type="danger">
                {JSON.stringify(error.response.data)}
              </Typography.Text>
            )
          })
        }
      }
    )
  }

  return (
    <Popconfirm
      title={
        'This will dispatch an email to the user with a new password. Click ok to confirm'
      }
      onConfirm={handleResetPassword}
      okText="Ok"
      cancelText="Cancel"
    >
      <Button type="primary">Reset Password</Button>
    </Popconfirm>
  )
}

ResetUserPasswordButton.propTypes = {
  userId: PropTypes.string.isRequired
}
